import React from "react";
import { GoSun } from "react-icons/go";
import { FiRefreshCw } from "react-icons/fi";
import orderImg from "../../assets/images/svgs/cards/orders.svg";
import delImg from "../../assets/images/svgs/cards/delivery.svg";
import { Utensils } from "lucide-react";

const SubscriptionCard = ({
  onCardClick,
  variant = "active",
  can_cancel,
  can_hold,
  can_renew,
  can_resume,
  status,
  image,
  title,
  currencySymbol,
  price,
  startDate,
  leftmeal,
  isEditClicked,
  quantity,
  mealType,
  deliveryType,
  mealsConsumed,
  startUpMessage,
  onCancelClick,
  onHoldClick,
  onRenewClick,
  onResumeClick,
}) => {
  const onHold = variant === "hold";
  const isCancelled = variant === "canceled";
  const isActive = variant === "active";
  const isInactive = variant === "inactive";
  const isUpcoming = variant === "upcoming";
  const isCompleted = variant === "completed";

  return (
    <div className="w-full max-w-xl mx-auto">
      {/* CARD */}
      <fieldset className="relative bg-white border border-[#FFCDC1] rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300  flex flex-col h-full">
        {/* Status Badge */}
        <legend
          className={`absolute -top-3 left-4 px-3 py-1 text-[12px] font-semibold 
  rounded-full border bg-white
  ${
    onHold
      ? "text-[#E9A626] border-[#E9A626]"
      : isInactive
        ? "text-gray-500 border-gray-200"
        : "text-[#FF6943] border-[#FFCDC1]"
  }`}
        >
          {status}
        </legend>

        {/* Body */}
        <div className="p-4 flex-1 cursor-pointer">
          {/* Header */}
          <div className="flex justify-between gap-3" onClick={onCardClick}>
            <div className="flex gap-3">
              {image ? (
                <img
                  src={image}
                  alt="dish"
                  className="h-12 w-12 rounded-lg object-cover border"
                />
              ) : (
                <div className="h-12 w-12 rounded-lg border flex items-center justify-center bg-gray-100">
                  <Utensils size={20} className="text-orange-500" />
                </div>
              )}

              <p className="text-sm font-semibold text-gray-900 leading-snug line-clamp-2">
                {title}
              </p>
            </div>

            <p className="font-semibold text-[#FF6943] whitespace-nowrap">
              {currencySymbol}
              {price}
            </p>
          </div>

          {/* Date */}
          <p className="text-xs text-gray-500 mt-2">Start Date : {startDate}</p>

          {/* Meta */}
          <div className="mt-3 grid grid-cols-3 gap-2 text-xs text-gray-700">
            <div className="flex items-center gap-1">
              <img src={orderImg} className="h-4 w-4" />
              {quantity}
            </div>

            <div className="flex items-center gap-1">
              <GoSun size={14} />
              {mealType}
            </div>

            <div className="flex items-center gap-1">
              <img src={delImg} className="h-4 w-4" />
              {deliveryType}
            </div>
          </div>

          {/* Actions Row */}
          <div className="mt-4 flex flex-wrap md:flex-nowrap items-center justify-between gap-3">
            {/* Meals */}
            {!isCompleted && !isUpcoming && !isCancelled && (
              <span className="text-xs px-3 py-1 rounded-full bg-[#FFEFEB] text-[#FF6943]">
                Meals Consumed ({mealsConsumed})
              </span>
            )}

            {/* Resume */}
            {onHold && can_resume && (
              <button
                onClick={onResumeClick}
                className="px-4 py-1.5 text-xs rounded-full bg-[#FF6943] text-white hover:bg-[#ff5730] transition"
              >
                Resume
              </button>
            )}

            {/* Active buttons */}
            {isActive && (
              <div className="flex gap-2 flex-wrap justify-end">
                {can_cancel && (
                  <button
                    onClick={onCancelClick}
                    className="px-4 py-1.5 text-xs rounded-full bg-[#FF6943] text-white hover:bg-[#ff5730] transition"
                  >
                    Cancel
                  </button>
                )}

                <button
                  onClick={isEditClicked}
                  className="px-4 py-1.5 text-xs rounded-full border border-[#FF6943] text-[#FF6943] hover:bg-[#FF6943] hover:text-white transition"
                >
                  Edit
                </button>

                {can_hold && (
                  <button
                    onClick={onHoldClick}
                    className="px-4 py-1.5 text-xs rounded-full border border-[#E9A626] text-[#E9A626] hover:bg-[#E9A626] hover:text-white transition"
                  >
                    Hold
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* FOOTER */}
        {isActive && (
          <div className="px-4 py-3 border-t border-[#FFCDC1] bg-[#FFF8F6] flex justify-between items-center">
            <span className="text-xs px-3 py-1 rounded-full bg-[#FFEFEB] text-[#FF6943]">
              {leftmeal}
            </span>

            <button
              onClick={onRenewClick}
              className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline"
            >
              <FiRefreshCw size={14} />
              Renew Subscription
            </button>
          </div>
        )}

        {isCancelled && (
          <div className="px-4 py-3 border-t border-[#FFCDC1] bg-[#FFF8F6] flex justify-between items-center">
            <span className="text-xs px-3 py-1 rounded-full bg-[#FFEFEB] text-[#FF6943]">
              Canceled
            </span>

            <button
              onClick={onRenewClick}
              className="flex items-center gap-2 text-sm text-[#FF6943] hover:underline"
            >
              <FiRefreshCw size={14} />
              Renew Subscription
            </button>
          </div>
        )}

        {isUpcoming && (
          <div className="px-4 py-3 border-t border-[#FFCDC1] bg-[#FFF8F6] flex justify-between items-center">
            <span className="text-xs px-3 py-1 rounded-full bg-[#FFEFEB] text-[#FF6943]">
              {startUpMessage}
            </span>

            <button className="px-4 py-1.5 text-xs rounded-full bg-[#FF6943] text-white hover:bg-[#ff5730] transition">
              Cancel
            </button>
          </div>
        )}

        {isCompleted && (
          <div className="px-4 py-3 border-t border-[#FFCDC1] bg-[#FFF8F6] flex justify-between items-center">
            <span className="text-xs px-3 py-1 rounded-full bg-[#FFEFEB] text-[#FF6943]">
              Meals Consumed ({mealsConsumed})
            </span>

            {can_renew && (
              <button
                onClick={onRenewClick}
                className="px-4 py-1.5 text-[10px] md:text-xs rounded-full bg-[#FF6943] text-white hover:bg-[#ff5730] transition"
              >
                Renew Subscription
              </button>
            )}
          </div>
        )}
      </fieldset>
    </div>
  );
};

export default SubscriptionCard;
